<template>
  <div>
    <h1>Bienvenido a la Página administrar</h1>
    <p>Contenido de la página administrar</p>
    <router-link to="/pagina2">Ir a la Página </router-link>
    <!-- Enlace a la Página 2 -->
  </div>
</template>

<script>
export default {
  name: "AdministrarUser",
};
</script>

<style scoped>
h1 {
  color: blue;
}
</style>
